/* cart-upsell.js
   Quick add for the "Complete your ritual" rail in the cart drawer.
   Adds one unit of the variant as a one-time purchase (no selling plan), then
   re-renders the drawer through the same sections round-trip the theme's ATC
   flow uses (see lunaire-atc-drawer.js). Buttons are type="button" so they can
   never submit the surrounding cart form. Event delegation keeps it working
   after Dawn replaces the drawer markup on re-render. */
(function () {
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var oldText = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding';

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    /* Ritual components must carry the hidden `_lunaire_ritual` property or the
       "Your PDRN serum is on us" function does not pay out and the cart lands
       at $185 against a page that says $182. snippets/cart-upsells decides
       WHETHER to tag (only when the cart's existing ritual lines are already
       tagged; a mixed set loses the gift too) and passes the bundle handle
       down on data-ritual-tag. This just carries it. */
    var ritualTag = btn.getAttribute('data-ritual-tag');
    if (ritualTag) body.append('properties[_lunaire_ritual]', ritualTag);
    body.append('sections', SECTIONS);
    body.append('sections_url', window.location.pathname);

    fetch('/cart/add', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body,
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status && response.status !== 200) {
          throw new Error(response.description || 'Could not add to cart');
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && response.sections) {
          /* Replaces the drawer contents, so the pressed button disappears
             with the old markup. No state to restore on success. */
          drawer.renderContents(response);
        } else if (typeof window.lunaireOpenCartDrawer === 'function') {
          window.lunaireOpenCartDrawer();
        } else {
          window.location.reload();
        }
      })
      .catch(function (e) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.textContent = oldText;
        alert(e && e.message ? e.message : 'Could not add to cart. Please try again.');
      });
  });
})();
